var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogoBinamikPay = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 103,
    height: 26.997,
    viewBox: "0 0 103 26.997",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0;}.b{fill:#2d2d2d;}.c{fill:none;stroke:#4d4dff;stroke-linecap:square;stroke-width:0.73px;}.d{fill:#1ed6bb;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 103,
    height: 26.997
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-828.452 -1652.074)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(866.452 1668.574)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M875.923,1672.141a4.348,4.348,0,0,1,2.531.625,2.135,2.135,0,0,1,.885,1.865,2.539,2.539,0,0,1-.242,1.156,1.981,1.981,0,0,1-.7.777,3.193,3.193,0,0,1-1.11.434,7.327,7.327,0,0,1-1.476.135h-.868v2.9h-1.094v-7.7a6.211,6.211,0,0,1,1.031-.152C875.261,1672.154,875.608,1672.141,875.923,1672.141Zm.09.958q-.7,0-1.071.034v3.065h.823a6.429,6.429,0,0,0,1.014-.073,2.314,2.314,0,0,0,.761-.248,1.227,1.227,0,0,0,.479-.479,1.589,1.589,0,0,0,.169-.778,1.43,1.43,0,0,0-.175-.744,1.308,1.308,0,0,0-.473-.467,2.056,2.056,0,0,0-.693-.243A4.946,4.946,0,0,0,876.014,1673.1Z",
    transform: "translate(-873.849 -1672.141)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M883.786,1674.473a3.017,3.017,0,0,1,1.065.164,1.73,1.73,0,0,1,.7.462,1.748,1.748,0,0,1,.378.71,3.433,3.433,0,0,1,.112.907v3.663l-.377.062c-.162.027-.344.051-.547.073s-.422.043-.659.062-.472.028-.705.028a3.852,3.852,0,0,1-.913-.1,2.053,2.053,0,0,1-.721-.321,1.468,1.468,0,0,1-.473-.58,2.029,2.029,0,0,1-.169-.868,1.669,1.669,0,0,1,.2-.834,1.577,1.577,0,0,1,.535-.564,2.488,2.488,0,0,1,.789-.316,4.29,4.29,0,0,1,.947-.1c.1,0,.214.007.327.018s.219.026.321.045l.265.05.158.034v-.293a2.34,2.34,0,0,0-.057-.513,1.191,1.191,0,0,0-.2-.45,1.025,1.025,0,0,0-.4-.316,1.568,1.568,0,0,0-.66-.119,4.973,4.973,0,0,0-.907.073,3.189,3.189,0,0,0-.58.152l-.124-.868a3.21,3.21,0,0,1,.677-.174A5.808,5.808,0,0,1,883.786,1674.473Zm.09,5.252c.248,0,.468-.006.659-.017a2.832,2.832,0,0,0,.479-.062V1677.9a1.353,1.353,0,0,0-.366-.1,4.139,4.139,0,0,0-.614-.04,3.99,3.99,0,0,0-.5.034,1.546,1.546,0,0,0-.485.141,1.026,1.026,0,0,0-.366.293.764.764,0,0,0-.147.49.842.842,0,0,0,.361.783A1.88,1.88,0,0,0,883.876,1679.725Z",
    transform: "translate(-875.321 -1672.591)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M888.175,1681.609a2.007,2.007,0,0,0,.321.106,1.739,1.739,0,0,0,1.358-.225,2.382,2.382,0,0,0,.631-.9q-.71-1.354-1.324-2.869a24.806,24.806,0,0,1-1.02-3.072h1.127q.125.507.3,1.094t.388,1.206q.214.621.462,1.24t.519,1.194q.427-1.182.743-2.344t.6-2.39h1.082q-.406,1.657-.9,3.185t-1.071,2.858a5.975,5.975,0,0,1-.468.873,2.618,2.618,0,0,1-.535.6,1.95,1.95,0,0,1-.659.349,2.81,2.81,0,0,1-.828.113,2.083,2.083,0,0,1-.259-.017c-.09-.011-.179-.027-.266-.045s-.166-.039-.237-.062a1.139,1.139,0,0,1-.153-.057Z",
    transform: "translate(-876.576 -1672.626)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(835.133 1654.809)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.201)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M835.133,1663.976V1655.3h8.673v4.08h-4.594v4.594h-4.08",
    transform: "translate(-835.133 -1655.303)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M850.653,1655.3h8.673v8.673h-4.08v-4.594h-4.593v-4.08",
    transform: "translate(-838.128 -1655.303)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M859.326,1670.823v8.673h-8.673v-4.08h4.593v-4.593h4.08",
    transform: "translate(-838.128 -1658.297)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M843.806,1679.5h-8.673v-8.673h4.08v4.593h4.594v4.08",
    transform: "translate(-835.133 -1658.297)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 4.82,
    height: 4.82,
    transform: "translate(12.82 7.799) rotate(90)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(866.46 1652.814)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M344.306,660.149a4.689,4.689,0,0,0-2.654.818v-4.692H339.33v12.994h2.322v-.563a4.693,4.693,0,1,0,2.654-8.557Zm0,7.076a2.388,2.388,0,1,1,2.4-2.388A2.392,2.392,0,0,1,344.306,667.225Z",
    transform: "translate(-339.33 -656.059)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M681.783,710.494v.564a4.7,4.7,0,1,0,0,7.729v.564h2.322v-8.857Zm-2.678,6.824a2.4,2.4,0,1,1,2.4-2.4A2.4,2.4,0,0,1,679.105,717.318Z",
    transform: "translate(-650.001 -706.141)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M485.641,654.776a1.446,1.446,0,0,1,.432-1.05,1.409,1.409,0,0,1,1.044-.44,1.473,1.473,0,0,1,1.476,1.49,1.4,1.4,0,0,1-.432,1.023,1.481,1.481,0,0,1-2.088,0A1.4,1.4,0,0,1,485.641,654.776Zm2.682,11.72h-2.394v-8.83h2.394Z",
    transform: "translate(-474.994 -653.286)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M548.447,714.765v5.094h-2.394V711h2.322v1.1a2.472,2.472,0,0,1,1.08-.99,3.33,3.33,0,0,1,1.476-.342,2.931,2.931,0,0,1,2.385.981,3.815,3.815,0,0,1,.819,2.529v5.581h-2.394v-5.167a1.93,1.93,0,0,0-.405-1.278,1.727,1.727,0,0,0-2.439.036A1.941,1.941,0,0,0,548.447,714.765Z",
    transform: "translate(-531.001 -706.65)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M833.978,719.629h-2.394v-8.857h2.286v1.08a2.387,2.387,0,0,1,1.08-.972,3.414,3.414,0,0,1,1.512-.36A2.638,2.638,0,0,1,839.091,712a3.132,3.132,0,0,1,2.808-1.476,3.059,3.059,0,0,1,3.2,3.366v5.743h-2.322v-5.256a1.822,1.822,0,0,0-.387-1.215,1.456,1.456,0,0,0-1.179-.459,1.516,1.516,0,0,0-1.188.5,1.8,1.8,0,0,0-.45,1.242v5.184H837.2v-5.256a1.8,1.8,0,0,0-.4-1.215,1.461,1.461,0,0,0-1.17-.459,1.55,1.55,0,0,0-1.206.495,1.789,1.789,0,0,0-.45,1.251Z",
    transform: "translate(-795.718 -706.42)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1038.076,654.776a1.447,1.447,0,0,1,.432-1.05,1.41,1.41,0,0,1,1.044-.44,1.473,1.473,0,0,1,1.476,1.49,1.4,1.4,0,0,1-.432,1.023,1.481,1.481,0,0,1-2.088,0A1.4,1.4,0,0,1,1038.076,654.776Zm2.682,11.72h-2.394v-8.83h2.394Z",
    transform: "translate(-987.228 -653.286)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1098.487,682.016v11.171h2.394v-2.34l.99-1.044,2.34,3.384h2.934l-3.618-5.13,3.546-3.726h-3.132l-3.06,3.294v-5.608Z",
    transform: "translate(-1043.208 -679.978)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogoBinamikPay);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logoBinamikPay.b7e71540e9f977719ae308eeadf30b56.svg";